export class APIError extends Error {
  constructor(message: string, code: string, status: number) {
    super(message)
    this.name = 'APIError'
    this.code = code
    this.status = status
  }
  code: string
  status: number
}

export class ClientError extends Error {
  constructor(message: string, code: string, url: string, cause: string) {
    super(message)
    this.name = 'ClientError'
    this.code = code
    this.url = url
    this.cause = cause
  }
  code: string
  url: string
  cause: string
}
